import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import draggable from "vuedraggable";
import YYImage from "@/pages/design/components/basic/image";
import no_img from '@/assets/noimg.png';
import FormEditPage from '@/pages/design/components/FormEditPage';
import CardItem from "@/pages/design/components/CardItem";
import Title from "@/pages/design/components/Title";
import FileUpload from "@/pages/design/components/FileUpload";
import { mapState } from 'vuex';
import defaultImage from '@/resource/images/default-banner.png';
export default {
  i18n: require('../../design_i18n'),
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    draggable: draggable,
    YYImage: YYImage,
    FormEditPage: FormEditPage,
    CardItem: CardItem,
    FileUpload: FileUpload,
    Title: Title
  },
  data: function data() {
    return {
      defaultImage: defaultImage,
      showSlide: false,
      curImgItem: 0 // 点击编辑图片时的索引
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    imgHost: function imgHost(state) {
      return state.design.imgHost;
    }
  })), {}, {
    list: function list() {
      if (!this.value[this.curImgItem].path) {
        return [];
      }
      return [this.$store.state.design.imgHost + this.value[this.curImgItem].path];
    },
    imgSrc: function imgSrc() {
      return function (path) {
        if (!path) return this.defaultImage;else return this.imgHost + path;
      };
    }
  }),
  methods: {
    handleConfirmDelete: function handleConfirmDelete(i) {
      this.value.splice(i, 1);
    },
    handleClearImg: function handleClearImg() {
      this.value[this.curImgItem].path = '';
    },
    handleUploadSuccess: function handleUploadSuccess(val) {
      /* let obj = this.value[curImgItem]
      * obj.path = val
          * this.value[curImgItem] = obj */
      this.value[this.curImgItem].path = val;
      this.$emit('input', this.value);
      /* Vue.set(this.value, curImgitem, obj) */
      /* this.value.splice(curImgItem, 1, obj) */
    },
    handleAddImg: function handleAddImg() {
      this.value.push({
        path: '',
        link: '',
        name: '',
        nameId: new Date().getTime()
      });
      this.curImgItem = this.value.length - 1;
      this.showSlide = true;
    },
    handleDeleteImg: function handleDeleteImg() {
      this.value.splice(this.curImgItem, 1);
      this.showSlide = false;
    },
    handleImgClick: function handleImgClick(i) {
      this.curImgItem = i;
      this.showSlide = true;
    }
  }
};